import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';
/**
 * @ignore - internal component.
 */

export default createSvgIcon(
/*#__PURE__*/
React.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');